import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { EMCAlarmLogType } from '../../../function/EMCModel';
import dayjs from 'dayjs';
import { TableBaseStyle, EMCTrendStyle } from './EMCTrendStyle';
import { ConvertDateToStringByDate } from './EMCTrend';
import { useTranslation } from 'react-i18next';

type EMCTrendErrorLogSelectDialogProps = {
  open: boolean;
  onClose: () => void;
  onSelect: (targetDate: string) => void;
  emcAlarmLogTypeList: EMCAlarmLogType[];
};

const EMCTrendErrorLogSelectDialog: React.FC<EMCTrendErrorLogSelectDialogProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const emcTrendStyle = EMCTrendStyle();
  const [selectIndex, setSelectIndex] = useState(0);
  const { t } = useTranslation();

  return (
    <>
      <Dialog open={props.open}>
        <DialogTitle id="alert-dialog-title">{t('EMCTrendErrorLogSelectDialog.アラーム発生日一覧','アラーム発生日一覧')}</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper} className={emcTrendStyle.tableContainer}>
            <Table stickyHeader aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell className={tableStyle.headerCell}>{'No'}</TableCell>
                  <TableCell className={tableStyle.headerCell}> {t('EMCTrendErrorLogSelectDialog.アラーム発生日時','アラーム発生日時')}</TableCell>
                  <TableCell className={tableStyle.headerCell}>{t('EMCTrendErrorLogSelectDialog.異常種別','異常種別')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.emcAlarmLogTypeList.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      key={index}
                      selected={selectIndex === row.rowIndex}
                      className={tableStyle.bodyRow}
                      onClick={() => {
                        setSelectIndex(row.rowIndex);
                      }}
                      onDoubleClick={(e) => {
                        console.debug('onDoubleClick');
                        props.onSelect(dayjs(row.COL_DATE).format());
                        props.onClose();
                      }}
                    >
                      <TableCell className={tableStyle.bodyCell}>{Number(index) + 1}</TableCell>
                      <TableCell className={tableStyle.bodyCell}>{ConvertDateToStringByDate(row.COL_DATE)}</TableCell>
                      <TableCell className={tableStyle.bodyCell}>{row.TYP_NAME}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            onClick={() => {
              props.onClose();
            }}
          >
            {t('EMCTrendErrorLogSelectDialog.閉じる','閉じる')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default EMCTrendErrorLogSelectDialog;
